import dayjs from '@crew/modules';
import { JsonDateFormat } from '@crew/enums/system';
import { TaskStateTypes } from '@crew/enums/app';
// タスクが期限切れか判定する
// 期限切れ：dueDateが今日より前 かつ taskStateが完了ではない
export const isTaskExpired = (dueDate, taskState) => {
    // taskStateが完了かチェック
    const isCompleted = taskState.taskStateType === TaskStateTypes.Completed.value;
    // 完了済の場合は期限切れとしない
    if (isCompleted)
        return false;
    // 期日が未設定の場合は期限切れとしない
    if (!dueDate)
        return false;
    const today = dayjs(new Date()).format(JsonDateFormat.YYYYMMDD);
    const due = dayjs(dueDate).format(JsonDateFormat.YYYYMMDD);
    // 期日が今日より小さい（前）であればtrue
    // 最初に完了済の場合はreturnしているので、ここでは日付の比較結果のみ返せばよい
    return due < today;
};
